<template>
    <div v-if="modelValue" class="fixed top-0 w-full h-full bg-black/50 z-[80] flex justify-center items-center">
        <div class="h-[42rem] border rounded-lg shadow shadow-gray-100 bg-white">
            <div class="px-7 py-6 flex justify-between items-center">
                <span class="text-xl font-bold"> Select Employee </span>
                <a href="javascript:void(0)" class="ml-20" @click="$emit('update:modelValue', false)">
                    <img src="@/assets/img/app-popup-1.svg" alt="app-popup-1" />
                </a>
            </div>
            <div class="w-full h-px bg-gray-200"></div>
            <div class="flex items-center gap-5 flex-wrap p-5">
                <div class="w-full flex items-center gap-5 flex-wrap">
                    <div class="flex gap-5">
                        <DesignDropdownSelect
                            v-model="searchDepartmentSeq"
                            :options="departmentOptions"
                            placeholder="All Departments"
                            :useDefaultMsg="true"
                            size="LG"
                            :width="'w-60'"
                            @change="fetchEmployeeList" />
                    </div>
                    <div>
                        <ElementsSearchBar
                            v-model="searchEmployeeName"
                            :options="employeeOptions"
                            :height12="true"
                            :width60="true"
                            :placeholder="'Search Employees'"
                            @searchEvent="fetchEmployeeList"
                            ref="employeeSearchBar"
                            :optionClickEvent="true"
                            :hasSearchButton="true"/>
                    </div>
                </div>
            </div>
            <div class="w-full h-px bg-gray-200"></div>
            <div>
                <div class="flex w-[963px]">
                    <div class="w-[379px] border-gray-300 border-r-[1px]">
                        <div class="title text-[#9CA2AB] font-medium text-[14px] px-[28px] py-2 shadow-sm">All Accounts</div>
                        <div class="h-[23rem] overflow-y-scroll cursor-pointer">
                            <ul>
                                <li v-if="searchEmployeeList.length === 0" class="flex flex-col items-center py-[15px] px-[31px]">
                                    <div class="ml-[10px] text-gray-500 text-15">No Data</div>
                                </li>
                                <template v-for="(employee, index) in searchEmployeeList" :key="index">
                                    <li
                                        class="flex items-center space-x-1 py-[8px] px-[31px] border-gray-300"
                                        :class="[index == 0 ? 'border-y-[1px]' : 'border-b-[1px]']"
                                        @click="addEmployee(employee)">
                                        <div class="flex items-center justify-center relative top-[-10px]">
                                            <StatusCircle :status-code="employee.employeeStatus" class=""/>
                                        </div>
                                        <div class="ml-1 col-span-4">
                                            <div class="name text-[14px] font-bold">{{ employee.employeeName }}</div>
                                            <div class="subject text-[14px] font-normal">{{ employee.departmentName }}</div>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <div class="employees_container mt-[15px] px-6 pt-6">
                        <div v-if="selectedEmployee == null" class="p-[24px] w-[528px] h-[289px] border-gray-300 rounded-[10px] border-[1px] text-center flex-col items-center">
                            <p class="text-center text-[#A8AAAC] text-[12px] mt-[90px] ml-[230px]">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-center">
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                            </p>
                            <p class="text-center text-[#A8AAAC] text-[12px] mt-[10px]">Click Employee</p>
                        </div>
                        <div v-else class="p-[24px] mt-[20px] w-[528px] h-289 border-gray-300 rounded-[10px] border-[1px] text-center flex-col items-center">
                            <div class="grid grid-flow-row-dense grid-cols-1 mt-[26px] max-h-[50vh] overflow-y-auto">
                                <div class="grid grid-rows-1 grid-cols-5 mb-3">
                                    <div class="ml-1 col-span-4">
                                        <div class="flex items-center gap-2">
                                            <div class="flex items-center justify-center relative top-[-10px]">
                                                <StatusCircle :status-code="selectedEmployee.employeeStatus" class=""/>
                                            </div>
                                            <div>
                                                <div class="text-[14px] font-bold text-left">{{ selectedEmployee.employeeName }}</div>
                                                <div class="subject text-[14px] font-normal text-left">{{ selectedEmployee.departmentName }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex items-center justify-center ml-8">
                                        <p class="text-[#8F969] text-[12px]" @click="deleteEmployee()">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="max-h-[70vh]">
                <div class="w-full h-px bg-gray-200"></div>
                <div class="px-4 py-6 flex justify-end gap-2">
                    <button
                        class="w-28 h-12 bg-white rounded flex items-center gap-2 justify-center text-gray-500 font-semibold text-sm border border-gray-300"
                        type="button"
                        @click="$emit('update:modelValue', false)">
                        Cancel
                    </button>
                    <button class="w-28 h-12 bg-indigo-600 rounded flex items-center gap-2 justify-center text-white font-semibold text-sm" type="submit" @click="saveEmployee">Add</button>
                </div>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <ConfirmPopupVue v-model="showMultiSelectError" confirmDescription="Only one person can be selected." buttonText="OK"></ConfirmPopupVue>
        <ConfirmPopupVue v-model="showNoSelectedEmployeeError" confirmDescription="Please select an employee." buttonText="OK"></ConfirmPopupVue>
    </Teleport>
</template>

<script>
import StatusCircle from '@/components/employee/status-circle/status-circle';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import ElementsSearchBar from '@/components/elements/ElementsSearchBar.vue';
import ConfirmPopupVue from '@/components/ConfirmPopup.vue';

export default {
    props: {
        employeeList: Array,
        modelValue: Boolean,
        givenEmployee: Object,
    },
    watch: {
        modelValue(newVal) {
            if (!newVal) return;

            const self = this;
            self.searchDepartmentSeq = '';
            self.departmentOptions = [];
            self.employeeOptions = [];
            self.searchEmployeeList = [...self.employeeList];

            if (self.givenEmployee != null) {
                self.selectedEmployee = self.givenEmployee;
            } else {
                self.selectedEmployee = null;
            }
            
            self.getDepartmentOptions();
            self.getEmployeeOptions();
        },
    },
    emits: ['save-employee', 'update:modelValue'],
    components: {
        StatusCircle,
        DesignDropdownSelect,
        ElementsSearchBar,
        ConfirmPopupVue,
    },
    mounted() {
        const self = this;
        self.getDepartmentOptions(); 
    },
    data() {
        return {
            searchEmployeeName: '',
            searchDepartmentSeq: '',
            departmentOptions: [],
            employeeOptions: [],
            searchEmployeeList: [],
            selectedEmployee: null,
            showMultiSelectError: false,
            showNoSelectedEmployeeError: false,
            statusOptions: [
                { text: 'Active', value: 'ACTIVE' },
                { text: 'Inactive', value: 'ON_LEAVE' },
                { text: 'Extension Required', value: 'EXTENSION_REQUIRED' },
                { text: 'Extension Past Due', value: 'EXTENSION_PAST_DUE' },
                { text: 'Contract Info Required', value: 'CONTRACT_INFO_REQUIRED' },
            ],
        };
    },
    methods: {
        getEmployeeOptions() {
            const self = this;
            self.employeeOptions = self.searchEmployeeList.map((employee) => ({ text: employee.employeeName, value: employee.employeeSeq }));
        },
        fetchEmployeeList() {
            const self = this;
            self.fetchEmployeeListByDepartment(self.searchDepartmentSeq);
            self.fetchEmployeeListByName(self.searchEmployeeName);
        },
        fetchEmployeeListByDepartment(departmentSeq) {
            const self = this;

            if (departmentSeq === null || departmentSeq === "") {
                self.searchEmployeeList = self.employeeList;
                return;
            }
            self.searchEmployeeList = self.employeeList.filter((employee) => employee.departmentSeq === departmentSeq);
        },
        fetchEmployeeListByName(employeeName) {
            const self = this;

            if (employeeName === null) {
                return;
            }

            let searchEmployeeNameUpper = employeeName.toUpperCase().trim();
            self.searchEmployeeList = self.searchEmployeeList.filter((employee) => employee.employeeName.toUpperCase().includes(searchEmployeeNameUpper));
        },
        getDepartmentOptions() {
            const self = this;

            const url = self.$api('uri', 'get-department');
            const json_query = JSON.stringify({
                showRootNode: true
            });
            self.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((dep) => ({
                    text: dep.departmentName,
                    value: dep.departmentSeq,
                }));

                self.departmentOptions.push(...options);
            });
        },
        addEmployee(employee) {
            const self = this;
            if (self.selectedEmployee != null) {
                self.showMultiSelectError = true;
                return;
            }

            self.selectedEmployee = employee;
        },
        deleteEmployee() {
            const self = this;
            self.selectedEmployee = null;
        },
        saveEmployee() {
            const self = this;
            if (self.selectedEmployee == null) {
                self.showNoSelectedEmployeeError = true;
                return;
            }
            self.$emit('save-employee', self.selectedEmployee);
        },
    },
};
</script>
